import exceljs from "exceljs";
import { saveAs } from "file-saver";
//--------------------------------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import {
    onlyUnique, 
    getDatefromWeekNum, 
    mimeTypeMap, 
    arrayReducer, 
    numberReducer, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function DataReport({
    filteredForms, 
    week, 
}){
    const user = useMyStore(state => state.user);
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const getPMNumber = (job) => {
        if(!job) return "";
        if(["Non Billable"].includes(job.category)){
            return "00000000";
        }else if(["Mob PGE", "DeMob PGE", "PGE PM Work", "PGE Field Meet"].includes(job.category)){
            return job.pmNumber ?? "";
        }else if(["Mob 3rd Party", "DeMob 3rd Party", "3rd Party Work", "3rd Party Field Meet", "Non Production"].includes(job.category)){
            return job.division?.slice(0, 8).replace("_", "") ?? "";
        }
        return "";
    }
    const handleDataReport = () => {
        setShowLoader(true);
        const mainData = filteredForms.map(raw => raw[week]);
        const workbook = new exceljs.Workbook();
        workbook.creator = user.userName;
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        //---- Payroll Hours (not minus lunch, not 2468) -----
        const worksheetPayRoll = workbook.addWorksheet("Payroll Hours");
        worksheetPayRoll.state = "visible";
        worksheetPayRoll.properties.defaultColWidth = 22.57;
        const headerArrPayRoll = ["Employee",...mainData.map(person => person.userName)];
        worksheetPayRoll.getColumn(1).values = headerArrPayRoll;
        for(let totalI = 0; totalI < 7; totalI++){
            const regularArr = mainData.map(person => 
                person.data[totalI][0].s ?? "0.00"
            );
            const oTArr = mainData.map(person => 
                person.data[totalI][0].o ?? "0.00"
            );
            worksheetPayRoll.getColumn(2 * totalI + 2).values = [`${getDatefromWeekNum(week, totalI)} Regular`,...regularArr.map(v => v === "0.00"?"":Number(v))];
            worksheetPayRoll.getColumn(2 * totalI + 3).values = [`${getDatefromWeekNum(week, totalI)} OT`,...oTArr.map(v => v === "0.00"?"":Number(v))];
        }
        const totalRegularArrPayRoll = mainData.map(person => person.s === "0.00"?"":Number(person.s));
        const totalOTArrPayRoll = mainData.map(person => person.o === "0.00"?"":Number(person.o));
        worksheetPayRoll.getColumn(2 * 7 + 2).values = [`Total Regular`,...totalRegularArrPayRoll];
        worksheetPayRoll.getColumn(2 * 7 + 3).values = [`Total OT`,...totalOTArrPayRoll];
        worksheetPayRoll.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                const columnLength = cell.value?
                cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1.1)
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });
        //---- Billable Hours (not minus lunch, not 2468) -----
        const worksheetBillable = workbook.addWorksheet("Billable Hours");
        worksheetBillable.state = "visible";
        worksheetBillable.properties.defaultColWidth = 22.57;
        const headerArr = ["Employee",...mainData.map(person => person.userName)];
        worksheetBillable.getColumn(1).values = headerArr;
        for(let totalI = 0; totalI < 7; totalI++){
            const regularArr = mainData.map(person => 
                person.data[totalI][0].bS || "0.00"
            );
            const oTArr = mainData.map(person => 
                person.data[totalI][0].bO || "0.00"
            );
            const regularArr2 = mainData.map(person => 
                person.data[totalI][0].bS2 || "0.00"
            );
            const oTArr2 = mainData.map(person => 
                person.data[totalI][0].bO2 || "0.00"
            );
            const regularArr3 = mainData.map(person => 
                person.data[totalI][0].bS3 || "0.00"
            );
            const oTArr3 = mainData.map(person => 
                person.data[totalI][0].bO3 || "0.00"
            );
            worksheetBillable.getColumn(6 * totalI + 2).values = [`${getDatefromWeekNum(week, totalI)} Regular`,...regularArr.map(v => v === "0.00"?"":Number(v))];
            worksheetBillable.getColumn(6 * totalI + 3).values = [`${getDatefromWeekNum(week, totalI)} OT`,...oTArr.map(v => v === "0.00"?"":Number(v))];
            worksheetBillable.getColumn(6 * totalI + 4).values = [`${getDatefromWeekNum(week, totalI)} Bill at Cost Regular`,...regularArr2.map(v => v === "0.00"?"":Number(v))];
            worksheetBillable.getColumn(6 * totalI + 5).values = [`${getDatefromWeekNum(week, totalI)} Bill at Cost OT`,...oTArr2.map(v => v === "0.00"?"":Number(v))];
            worksheetBillable.getColumn(6 * totalI + 6).values = [`${getDatefromWeekNum(week, totalI)} Round up Bill at Cost Regular`,...regularArr3.map(v => v === "0.00"?"":Number(v))];
            worksheetBillable.getColumn(6 * totalI + 7).values = [`${getDatefromWeekNum(week, totalI)} Round up Bill at Cost OT`,...oTArr3.map(v => v === "0.00"?"":Number(v))];
        
        }
        const totalRegularArr = mainData.map(person => person.bS === "0.00" && person.bS2 === "0.00" && person.bS3 === "0.00"?"":Number(person.bS) + Number(person.bS2) + Number(person.bS3));
        const totalOTArr = mainData.map(person => person.bO === "0.00" && person.bO2 === "0.00" && person.bO3 === "0.00"?"":Number(person.bO) + Number(person.bO2) + Number(person.bO3));
        worksheetBillable.getColumn(6 * 7 + 2).values = [`Total Regular`,...totalRegularArr];
        worksheetBillable.getColumn(6 * 7 + 3).values = [`Total OT`,...totalOTArr];
        worksheetBillable.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                const columnLength = cell.value?
                cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1.1)
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });
        //---- Mileage -----
        const worksheet2 = workbook.addWorksheet("Mileage");
        worksheet2.state = "visible";
        worksheet2.properties.defaultColWidth = 22.57;
        worksheet2.getColumn(1).values = headerArr;
        for(let totalI = 0; totalI < 7; totalI++){
            //here
            const mileage = mainData.map(userInfo => userInfo.data[totalI][0].mileage);
            worksheet2.getColumn(totalI + 2).values = [`${getDatefromWeekNum(week, totalI)} Day Mileage`,...mileage];
        }
        const totalMilage = mainData.map(userInfo => userInfo.mileage);
        worksheet2.getColumn(7 + 2).values = [`Total Mileage`,...totalMilage];
        worksheet2.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                const columnLength = cell.value?
                cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1.1)
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });
        //---- Expense -----
        const worksheet21 = workbook.addWorksheet("Expense");
        worksheet21.state = "visible";
        worksheet21.properties.defaultColWidth = 22.57;
        worksheet21.getColumn(1).values = headerArr;
        for(let totalI = 0; totalI < 7; totalI++){
            //here
            const expesne = mainData.map(userInfo => Number(userInfo.data[totalI][0].h || "0") + Number(userInfo.data[totalI][0].to || "0"));
            worksheet21.getColumn(totalI + 2).values = [`${getDatefromWeekNum(week, totalI)} Day Expense`,...expesne.map(v => v === 0?"":v)];
        }
        const totalExpesne = mainData.map(userInfo => Number(userInfo.hotelExpensesTotal || "0") + Number(userInfo.tollExpensesTotal || "0"));
        worksheet21.getColumn(7 + 2).values = [`Total Expense`,...totalExpesne.map(v => v === 0?"":v)];
        worksheet21.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                const columnLength = cell.value?
                cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1.1)
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });
        //---- Subsistence -----
        const worksheet3 = workbook.addWorksheet("Subsistence Payroll");
        worksheet3.state = "visible";
        worksheet3.properties.defaultColWidth = 22.57;
        worksheet3.getColumn(1).values = headerArr;
        for(let totalI = 0; totalI < 7; totalI++){
            const workStatus = mainData.map(userInfo => userInfo.data[totalI].slice(1).find(job => 
                ![
                    "Rest",
                    "Lunch", 
                    "Hotel Charges 3rd Party", 
                    "Hotel Charges PGE", 
                    "Toll Charges 3rd Party", 
                    "Toll Charges PGE"
                ].includes(job.category)
            )?"Work":"");
            worksheet3.getColumn(totalI + 2).values = [`${getDatefromWeekNum(week, totalI)}`,...workStatus];
        }
        worksheet3.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                const columnLength = cell.value?
                cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1.1)
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });
        //---- Subsistence Billable -----
        const worksheet31 = workbook.addWorksheet("Subsistence Billable");
        worksheet31.state = "visible";
        worksheet31.properties.defaultColWidth = 22.57;
        worksheet31.getColumn(1).values = headerArr;
        for(let totalI = 0; totalI < 7; totalI++){
            const workStatus = mainData.map(userInfo => 
                getPMNumber(userInfo.data[totalI].slice(1).find(job => 
                    ![
                        "Rest",
                        "Lunch", 
                        "Hotel Charges 3rd Party", 
                        "Hotel Charges PGE", 
                        "Toll Charges 3rd Party", 
                        "Toll Charges PGE"
                    ].includes(job.category)
                ))
            );
            worksheet31.getColumn(totalI + 2).values = [`${getDatefromWeekNum(week, totalI)}`,...workStatus];
        }
        worksheet31.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                const columnLength = cell.value?
                cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1.1)
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });
        //----- standby pms hours ------
        const worksheet4 = workbook.addWorksheet("standby pms hours");
        worksheet4.state = "visible";
        worksheet4.properties.defaultColWidth = 22.57;
        const pms = mainData.map(person => person.data)
        .reduce(arrayReducer, []).map(day => day.slice(1))
        .reduce(arrayReducer, [])
        .filter(job => ![
            "Rest",
            "Lunch", 
            "Non Billable", 
            "Hotel Charges 3rd Party", 
            "Hotel Charges PGE", 
            "Toll Charges 3rd Party", 
            "Toll Charges PGE"
        ].includes(job.category))
        .map(raw => getPMNumber(raw))
        .filter(onlyUnique);
        pms.unshift("00000000");
        // ---------------
        const pmHeaderArr = ["PMs",...pms];
        worksheet4.getColumn(1).values = pmHeaderArr;
        const _totalRegularArr1 = [];
        const _totalOTArr1 = [];
        const _totalRegularArr2 = [];
        const _totalOTArr2 = [];
        // const _totalRegularArr3 = [];
        // const _totalOTArr3 = [];
        for(let totalI = 0; totalI < 7; totalI++){
            const pmData = mainData.map(userInfo => userInfo.data[totalI]).reduce(arrayReducer, []);
            const regularArr = pms.map(p => pmData.filter(t => getPMNumber(t) === p).map(t => Number(t.bS || "0") + Number(t.bS3 || "0")).reduce(numberReducer, 0).toFixed(2));
            const oTArr = pms.map(p => pmData.filter(t => getPMNumber(t) === p).map(t => Number(t.bO || "0") + Number(t.bO3 || "0")).reduce(numberReducer, 0).toFixed(2));
            const regularArr2 = pms.map(p => pmData.filter(t => getPMNumber(t) === p).map(t => Number(t.bS2 || "0")).reduce(numberReducer, 0).toFixed(2));
            const oTArr2 = pms.map(p => pmData.filter(t => getPMNumber(t) === p).map(t => Number(t.bO2 || "0")).reduce(numberReducer, 0).toFixed(2));
            // const regularArr3 = pms.map(p => pmData.filter(t => getPMNumber(t) === p).map(t => Number(t.bS3 || "0")).reduce(numberReducer, 0).toFixed(2));
            // const oTArr3 = pms.map(p => pmData.filter(t => getPMNumber(t) === p).map(t => Number(t.bO3 || "0")).reduce(numberReducer, 0).toFixed(2));
            oTArr[0] = pmData.filter(t => getPMNumber(t) === "00000000").map(t => Number(t.o || "0")).reduce(numberReducer, 0).toFixed(2);
            regularArr[0] = pmData.filter(t => getPMNumber(t) === "00000000").map(t => Number(t.s || "0")).reduce(numberReducer, 0).toFixed(2);
            const v1 = regularArr.map(v => v === "0.00"?"":Number(v));
            worksheet4.getColumn(4 * totalI + 2).values = [`${getDatefromWeekNum(week, totalI)} Regular`,...v1];
            _totalRegularArr1.push(v1.map(v => v || 0));
            const v2 = oTArr.map(v => v === "0.00"?"":Number(v));
            worksheet4.getColumn(4 * totalI + 3).values = [`${getDatefromWeekNum(week, totalI)} OT`,...v2];
            _totalOTArr1.push(v2.map(v => v || 0));
            const v3 = regularArr2.map(v => v === "0.00"?"":Number(v));
            worksheet4.getColumn(4 * totalI + 4).values = [`${getDatefromWeekNum(week, totalI)} Bill at Cost Regular`,...v3];
            _totalRegularArr2.push(v3.map(v => v || 0));
            const v4 = oTArr2.map(v => v === "0.00"?"":Number(v));
            worksheet4.getColumn(4 * totalI + 5).values = [`${getDatefromWeekNum(week, totalI)} Bill at Cost OT`,...v4];
            _totalOTArr2.push(v4.map(v => v || 0));
            // const v5 = regularArr3.map(v => v === "0.00"?"":Number(v));
            // worksheet4.getColumn(6 * totalI + 6).values = [`${getDatefromWeekNum(week, totalI)} Round up Bill at Cost Regular`,...v5];
            // _totalRegularArr3.push(v5.map(v => v || 0));
            // const v6 = oTArr3.map(v => v === "0.00"?"":Number(v));
            // worksheet4.getColumn(6 * totalI + 7).values = [`${getDatefromWeekNum(week, totalI)} Round up Bill at Cost OT`,...v6];
            // _totalOTArr3.push(v6.map(v => v || 0));
        }
        const func = (pms, arr) => {
            const r1 = [];
            for(let x = 0; x < pms.length; x++){
                let temp = 0;
                for(let xx = 0; xx < 7; xx++){
                    temp += arr[xx][x];
                }
                r1.push(temp);
            }
            return r1;
        }
        worksheet4.getColumn(6 * 7 + 2).values = [`Total Regular`,...func(pms, _totalRegularArr1)];
        worksheet4.getColumn(6 * 7 + 3).values = [`Total OT`,...func(pms, _totalOTArr1)];
        worksheet4.getColumn(6 * 7 + 4).values = [`Total Bill at Cost Regular`,...func(pms, _totalRegularArr2)];
        worksheet4.getColumn(6 * 7 + 5).values = [`Total Bill at Cost OT`,...func(pms, _totalOTArr2)];
        // worksheet4.getColumn(6 * 7 + 6).values = [`Total Round up Bill at Cost Regular`,...func(pms, _totalRegularArr3)];
        // worksheet4.getColumn(6 * 7 + 7).values = [`Total Round up Bill at Cost OT`,...func(pms, _totalOTArr3)];
        worksheet4.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                const columnLength = cell.value?
                cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1.1)
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });

            //----- standby pms mileage ------
            const worksheet5 = workbook.addWorksheet("standby pms mileage");
            worksheet5.state = "visible";
            worksheet5.properties.defaultColWidth = 22.57;
            worksheet5.getColumn(1).values = pmHeaderArr;
            const _total = [];
            for(let totalI = 0; totalI < 7; totalI++){
                const pmData = mainData.map(userInfo => userInfo.data[totalI]).reduce(arrayReducer, []);
                const miles = pms.map(p => pmData.filter(t => getPMNumber(t) === p).map(t => Number(t.mobMileage || "0")).reduce(numberReducer, 0).toFixed(2));
                miles[0] = pmData.filter(t => getPMNumber(t) === "00000000").map(t => Number(t.mobMileage || "0")).reduce(numberReducer, 0).toFixed(2);
                const vv = miles.map(v => v === "0.00"?"":Number(v));
                worksheet5.getColumn(1 * totalI + 2).values = [`${getDatefromWeekNum(week, totalI)}`,...vv];
                _total.push(vv.map(v => v || 0));
            }
            worksheet5.getColumn(1 * 7 + 2).values = [`Total`,...func(pms, _total)];
            worksheet5.columns.forEach(column => {
                const minLength = 18;
                let maxLength = 0;
                column["eachCell"]({ includeEmpty: true }, cell => {
                    const columnLength = cell.value?
                    cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1.1)
                    :minLength;
                    if(columnLength > maxLength){
                        maxLength = columnLength;
                    }
                });
                column.width = maxLength < minLength ? minLength : maxLength;
            });
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), 
            `Outside Service ${week}.xlsx`);
            setShowLoader(false);
        });
    }
    //--------------------------------------------------------------------------------------------
    return(
        <span className = "pointer"
            onClick = {handleDataReport}
        >
            Data Report
        </span>
    )
}